import dayjs from 'dayjs'
import { nextWeekdayAfter } from '@/helpers/dateHelper'
import { formatDate } from '@/filters/dateFormatter'
import { PLACEMENT_STATUSES, ENTITIES, PLACED } from './constants'

const THIRTY = 30
const GRANULARITY_OF_LAST_AVAILABLE_DAY = 'day'
export const INTEGER_REPRESENTING_NO_EXPERIENCE = 1
export const AMOUNT_OF_DAYS_TO_FILTER_INACTIVE_ENGAGEMENTS = 10

export const isLastAvailableDayAfter30Days = (lastAvailableDay) =>
  dayjs(lastAvailableDay).isAfter(dayjs().add(THIRTY, GRANULARITY_OF_LAST_AVAILABLE_DAY))

export const onAClientOrLastAvailableDayFilter = (user) =>
  user.currentStaffingRoles.length > 0 ||
  !user.lastAvailableDay ||
  isLastAvailableDayAfter30Days(user.lastAvailableDay)

export const lastAvailableDayWithClient = (lastAvailableDay, endDate) =>
  nextWeekdayAfter(dayjs.min(dayjs(lastAvailableDay), dayjs(endDate)))

// Placements helpers
const compareByStatus = (a, b) =>
  PLACEMENT_STATUSES.indexOf(b.status) - PLACEMENT_STATUSES.indexOf(a.status)

const compareByDateDescending = (a, b) =>
  dayjs(a.nextAvailableDate).isAfter(dayjs(b.nextAvailableDate)) ? 1 : -1

export const sortedPlacements = (usersWithPlacements) =>
  usersWithPlacements.sort((a, b) => compareByStatus(a, b) || compareByDateDescending(a, b))

export const buildPlacement = (id, staffingRoleId, status, user) => {
  if (!user) return
  return {
    id,
    staffingRoleId,
    status,
    userId: user.id,
    userName: user.name,
    userTier: user.tier,
    userPercentageUtilization: user.percentageUtilization,
    nextAvailableDate: formatDate(user.nextAvailableDate),
  }
}

// StaffingRoles helpers
export const _getAllPlacedStaffingRolesForAGivenConsultant = (state, consultantId) => {
  const consultantPlacements = state.placements.filter(
    (p) => p.userId === consultantId && p.status === PLACED
  )
  return consultantPlacements.reduce((result, placement) => {
    const role = state.staffingRoles.find((r) => r.id === placement.staffingRoleId)
    if (role) result.push(role)
    return result
  }, [])
}

export const _isStaffingRoleCurrent = (role) =>
  dayjs().isBetween(role.startDate, role.endDate, 'day', '[]')

export const _managerNames = (staffingRole, getEntityById) =>
  staffingRole.managerId ? getEntityById(ENTITIES.USERS, staffingRole.managerId).name : null

// Clients helpers
export function compareByEndDateDesc(first, second) {
  if (first.endDate < second.endDate) return 1
  if (second.endDate < first.endDate) return -1
  return 0
}
